// src/data/hero.js

const heroData = {
    profileImage: "/profile.jpg",
    greeting: "Hello, I'm",
    name: "Ritwik Pradhan",
    tagline:[
      "Full-Stack JavaScript Developer",
      "Angular, Node.js, AWS, PostgreSQL",
      "10+ Years Experience in Leadership, Architecture & Delivery",
    ],
    description:
      "I specialize in building scalable applications and leading cross-functional teams. With a solid foundation in finance and project management, I align technology with business goals to deliver impact. Passionate about modern web tech, clean code, and mentoring engineers.",
    buttonText: "Contact Me",
    buttonLink: "/contact",
  };
  
  export default heroData;
  